import { ChatState } from '@app/hooks'

import { Conversation, Participant } from '@app/models'

import {
  getEmailWithFallback,
  getTranslatedData,
  isEmail,
  shouldFallbackToAccount,
} from '.'
import { obfuscate } from './obfuscate'

export const getBaseInfo = (
  state: ChatState,
  participant: Participant | null,
  conversation: Conversation | null
) => {
  if (!participant || !conversation)
    return {
      avatar: null,
      fullName: '',
      language: '',
      country: '',
      phone: '',
    }
  const mustObfuscate = !!participant?.hasDetailsHidden
  const showAccount = shouldFallbackToAccount(participant, conversation)

  const contactAccount =
    conversation.contactAccountId &&
    state.accounts.get(conversation.contactAccountId)

  if (showAccount && contactAccount) {
    const language = contactAccount?.regionalSettings?.language
    const country = contactAccount?.regionalSettings?.countryISO
    let fullName = getTranslatedData(contactAccount?.name || [], language)
    if (isEmail(fullName)) {
      fullName = fullName.split('@')[0]
    }
    const avatar = contactAccount?.logo || null
    return {
      avatar,
      fullName,
      language,
      country,
      phone: '',
    }
  }

  let fullName = participant.fullName || getEmailWithFallback(participant)

  if (isEmail(fullName)) {
    fullName = fullName.split('@')[0]
  }

  const language = participant.language || ''
  const country = participant.countryISO || ''
  const avatar = participant.avatar ?? null
  const participantPhoneRaw = participant.phone || ''
  const phone = mustObfuscate
    ? obfuscate(participantPhoneRaw)
    : participantPhoneRaw

  return {
    avatar,
    fullName,
    language,
    country,
    phone,
  }
}
